import { render, staticRenderFns } from "./CreateSatisfactionComponent.vue?vue&type=template&id=6dc66eb9&"
import script from "./CreateSatisfactionComponent.vue?vue&type=script&lang=js&"
export * from "./CreateSatisfactionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports